//自己的个人信息
var OwnInfo = {
  id: '',
  soaToken: '',
  channelNo: '',
  
  nickname: '',
  userNo: '',
  head: '',
  sign: '',
  sex: 1,
  
  phone: '',
  
  rpRewarded: 0,
  rpMaxNum: 10,
  
  money: 0,
  
  hobby: '',
  location: {lng: 116.403119, lat: 39.917813, city: '北京市', addr: '北京市'},
  
  alipayPayee: '',
  alipay: '',
  
  gainAll: 0,
  costAll: 0,
  goodLuck: 0,
  
  firstWeal: false,
  firstrp: false,
  
  type: 1,
  
  idCard: null,
  
  // 是否登录成功
  loginOK: false,
  _publishNum: 0,
  
  init: function (ctx) {
    let cache = ctx.$preference.getOwnInfo()
    this.phone = ctx.$preference.getPhoneAccount()
    this.parse(null, cache)
    this.loginOK = false;
    this._publishNum = 0;
    this.location = ctx.$preference.getLocation()
  },
  
  parse: function (ctx, data) {
    if (data != null) {
      this.id = data.id || this.id;
      this.soaToken = data.soaToken || this.soaToken;
      
      this.nickname = data.nickname || this.nickname;
      this.userNo = data.userNo || this.userNo;
      
      if (data.hasOwnProperty('firstWeal')) {
        this.firstWeal = data.firstWeal
      }
      
      if(data.hasOwnProperty('idCard')){
        this.idCard = data.idCard
      }
      
      this.nicknameFlag = data.nicknameFlag || this.nicknameFlag;
      this.type = data.type || this.type;
      
      this.money = data.money || this.money;
      
      this.rpRewarded = data.takeCount || this.rpRewarded
      
      this.head = data.head || this.head
      
      this.sign = data.sign || this.sign
      this.sex = data.sex || this.sex
      
      this.phone = data.phone || this.phone
      
      this.hobby = data.hobby || this.hobby
      this.alipayPayee = data.alipayPayee || this.alipayPayee
      
      this.alipay = data.alipay || this.alipay
      
      this.gainAll = data.gainAll || this.gainAll
      this.costAll = data.costAll || this.costAll
      this.goodLuck = data.goodLuck || this.goodLuck
      this.location = data.location || this.location
      
      if (ctx != null) {
        let obj = {id: this.id, soaToken: this.soaToken, userNo: this.userNo}
        ctx.$preference.saveOwnInfo(this)
      }
    }
    return this;
  },
  
  //是否是游客账号
  isGuestAccount() {
    return this.type == 1
  },
  
  //是否是手机号账号
  isPhoneAccount(){
    return this.type == 2
  },
  
  //是否是手微信浏览器
  isWxinBrowserAccount(){
    return this.type == 3
  },
  
  //是否是app微信
  isWxinAppAccount(){
    return this.type == 3 && isNativeClient()
  },
  
  Attestation: function () {
    return this.idCard == null
  },
  
  onPublishOK() {
    if (this._publishNum == 0) {
      this._publishNum = 1;
    }
    this._publishNum += 0.25;
    if (this._publishNum > 3) {
      this._publishNum = 3;
    }
  },
  
  getPublishLat() {
    return this.location.lat + (Math.random() * this._publishNum - this._publishNum / 2) / 500
  },
  
  getPublishLng() {
    return this.location.lng + (Math.random() * this._publishNum - this._publishNum / 2) / 500
  },
  
  logout() {
    this.loginOK = false
    this.id = 0
    this.soaToken = ""
    this.clearInfo()
  },
  
  clearInfo() {
    this.nickname = ''
    this.userNo = ''
    this.head = ''
    this.sign = ''
    this.sex = 1
    this.phone = ''
    
    this.rpRewarded = 0
    this.rpMaxNum = 10
    
    this.money = 0
    
    this.hobby = ''
    
    this.alipayPayee = ''
    this.alipay = ''
    
    this.gainAll = 0
    this.costAll = 0
    this.goodLuck = 0
    
    this.firstWeal = false
    this.firstrp = false
    
    this.type = 1
    
    this.idCard = null;
    
    this._publishNum = 0
  }
}

OwnInfo.install = function (Vue, options) {
  Vue.prototype.$info = OwnInfo
}

export default OwnInfo;




// WEBPACK FOOTER //
// ./src/plugins/own-info.js